import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TSessionSummaryReport } from "../../types/types";
import { sessionSummaryApi } from "../api/sessionSummary.api";

interface SessionSummaryState {
  data: TSessionSummaryReport | null;
  loading: boolean;
  error?: string;
}

const initialState: SessionSummaryState = {
  data: null,
  loading: false,
  error: undefined,
};

const treatmentReportSummarySlice = createSlice({
  name: "sessionSummary",
  initialState,
  reducers: {
    updateReport(state, action: PayloadAction<TSessionSummaryReport>) {
      state.data = action.payload;
    },
    clearSessionSummary(state) {
      state.data = null;
      state.loading = false;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      sessionSummaryApi.endpoints.getSessionSummaryReport.matchFulfilled,
      (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.error = undefined;
      }
    );
    builder.addMatcher(
      sessionSummaryApi.endpoints.getSessionSummaryReport.matchPending,
      (state) => {
        state.loading = true;
        state.error = undefined;
      }
    );
    builder.addMatcher(
      sessionSummaryApi.endpoints.getSessionSummaryReport.matchRejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error?.message;
      }
    );
  },
});

export const { actions, reducer } = treatmentReportSummarySlice;
export default treatmentReportSummarySlice.reducer;
